export const removeBulletListPrefixes = (str: string) => str.replace(/^-\s*/gm, '')
export const removeNumberedListPrefixes = (str: string) => str.replace(/^\d\.\s*/gm, '')
export const removeSurroundingQuotes = (str: string) => str.replace(/^"/gm, '').replace(/"$/gm, '')
export const trim = (str: string) => str.trim()
